import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bell, BellDot } from "lucide-react";
import { useAuth } from "../lib/auth";
import api from "../lib/api";

export default function NotificationBell() {
    const { user } = useAuth();
    const [count, setCount] = useState(0);
    const [hasPrefs, setHasPrefs] = useState(false);
    const nav = useNavigate();

    useEffect(() => {
        if (!user) { setCount(0); return; }
        let cancelled = false;
        async function poll() {
            try {
                const { data } = await api.get("/alerts/unread-count");
                if (cancelled) return;
                setCount(data.count || 0);
                setHasPrefs(!!data.has_prefs);
            } catch {}
        }
        poll();
        const int = setInterval(poll, 60_000);
        return () => { cancelled = true; clearInterval(int); };
    }, [user]);

    if (!user) return null;
    const showDot = count > 0;
    return (
        <button
            onClick={() => nav("/alerts")}
            data-testid="notification-bell"
            className="relative p-1.5 rounded-full hover:bg-[var(--rl-cream)] transition-colors"
            title={hasPrefs ? `${count} new matching dog${count === 1 ? "" : "s"}` : "Set up alerts"}
        >
            {showDot ? <BellDot className="w-5 h-5 text-[var(--rl-urgent)]" /> : <Bell className="w-5 h-5 text-[var(--rl-text-2)]" />}
            {showDot && (
                <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[var(--rl-urgent)] text-white text-[10px] font-semibold flex items-center justify-center urgent-pulse" data-testid="notification-count">
                    {count > 99 ? "99+" : count}
                </span>
            )}
        </button>
    );
}
